<template>
  <div class="flex flex-shrink-0 gap-2">
    <div
      v-for="item in placeGroupsList"
      :key="item.id"
      class="flex flex-auto cursor-pointer flex-row gap-2 overflow-hidden rounded border"
      :class="[modelValue === item.id ? 'border-primay-300 font-medium' : '']"
      @click="$emit('update:modelValue', item.id)"
    >
      <span
        class="flex flex-shrink-0 items-center bg-gray-50 px-2"
        :class="[modelValue === item.id ? 'bg-primary-300 text-white' : '']"
      >
        <FontAwesomeIcon :icon="item.icon" />
      </span>
      <span class="flex-1 px-2 py-1">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SelectPlaceGroup',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: String,
      required: true
    },
    placeGroupsList: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped></style>
